import { configureStore } from '@reduxjs/toolkit'
import appMiddleware from './middleware/appMiddleWare'
import userDataMiddleware from './middleware/userDataMiddleware'
import userSlice from './slices/userSlice'
import authSlice from './slices/authSlice'
import appSlice from './slices/appSlice'

export const store = configureStore({
  reducer: {
    auth: authSlice,
    user: userSlice,
    app: appSlice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(appMiddleware.middleware).prepend(userDataMiddleware.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
